"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DbIndexNames;
(function (DbIndexNames) {
    DbIndexNames["GSI1"] = "GSI1";
    DbIndexNames["GSI2"] = "GSI2";
    DbIndexNames["GSI3"] = "GSI3";
    DbIndexNames["GSI4"] = "GSI4";
    DbIndexNames["GSI5"] = "GSI5";
    DbIndexNames["GSI6"] = "GSI6";
    DbIndexNames["GSI7"] = "GSI7";
    DbIndexNames["GSI8"] = "GSI8";
    DbIndexNames["GSI9"] = "GSI9";
    DbIndexNames["GSI10"] = "GSI10";
    DbIndexNames["GSI11"] = "GSI11";
    DbIndexNames["GSI12"] = "GSI12";
})(DbIndexNames = exports.DbIndexNames || (exports.DbIndexNames = {}));
//# sourceMappingURL=indexNames.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@prolaera/types/dist/enums/indexNames.js
// module id = 876
// module chunks = 0